import { render } from "./login-popup.vue?vue&type=template&id=17f8793c&scoped=true"
import script from "./login-popup.vue?vue&type=script&lang=js"
export * from "./login-popup.vue?vue&type=script&lang=js"

import "./login-popup.vue?vue&type=style&index=0&id=17f8793c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17f8793c"

export default script